// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2c9edc03] .lds-ring div {\n  margin: auto;\n}", "",{"version":3,"sources":["webpack://./resources/js/v2/components/form/input.vue"],"names":[],"mappings":"AACA;EACC,YAAA;AAAD","sourcesContent":["\n::v-deep(.lds-ring div) {\n\tmargin: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
